import React from "react";

function Run({ run }) {
  const parts = run.text.split("\n");
  let node = parts.map((part, index) => (
    <span key={index}>
      {index > 0 ? <br /> : null}
      {part}
    </span>
  ));

  if (run.italic) node = <em>{node}</em>;
  if (run.bold) node = <strong>{node}</strong>;
  if (run.href) {
    const external = /^https?:/i.test(run.href) || run.href.startsWith("mailto:");
    node = (
      <a
        href={run.href}
        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        {node}
      </a>
    );
  }

  return node;
}

function Runs({ runs }) {
  return runs?.map((run, index) => <Run key={index} run={run} />);
}

function Blocks({ blocks }) {
  return blocks?.map((block, index) => <Block key={index} block={block} />);
}

function List({ items }) {
  return (
    <ul>
      {items.map((item, index) => (
        <li key={index}>
          <Runs runs={item.runs} />
          {item.children?.length ? <List items={item.children} /> : null}
        </li>
      ))}
    </ul>
  );
}

function Table({ rows }) {
  const header = rows.length > 1 ? rows[0] : null;
  const body = rows.length > 1 ? rows.slice(1) : rows;

  return (
    <div className="table-container">
      <table className="styled-table">
        {header ? (
          <thead>
            <tr>
              {header.map((cell, index) => (
                <th key={index}>
                  <Blocks blocks={cell} />
                </th>
              ))}
            </tr>
          </thead>
        ) : null}
        <tbody>
          {body.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>
                  <Blocks blocks={cell} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function Block({ block }) {
  if (block.type === "h") {
    const Tag = !block.level || block.level <= 1 ? "h1" : "h2";
    return (
      <Tag>
        <Runs runs={block.runs} />
      </Tag>
    );
  }

  if (block.type === "ul") return <List items={block.items} />;
  if (block.type === "table") return <Table rows={block.rows} />;

  return (
    <p>
      <Runs runs={block.runs} />
    </p>
  );
}

export default function LegalDocument({ document }) {
  return (
    <article className="legal-document">
      <Blocks blocks={document.blocks} />
    </article>
  );
}
